// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rCtD","left":"styles_left__227_s"};